const Home = () => {
  window.location.href = "https://mantisxr.com";
  return (
    <>
      Redirecting to MantisXR.
    </>
  )
}

export default Home;
